import ContentPanel from './ContentPanel';
import { H3 } from './utils';

const TestimonialSection = ({
  isDesktopLarge = false,
  quote,
  name,
  title,
  avatarSrc,
}: {
  /* Awkward; one quote needs to be an <H1> only on desktop */
  isDesktopLarge?: boolean;
  quote: string;
  name: string;
  title: string;
  avatarSrc: string;
}) => {
  return (
    <ContentPanel background='light-gray'>
      <div className='text-center'>
        {isDesktopLarge && (
          <div className='text-gray-600 text-2xl leading-8 font-medium'>{quote}</div>
        )}
        {!isDesktopLarge && <H3>{quote}</H3>}
      </div>
      <div className='flex flex-col items-center'>
        <img src={avatarSrc} className='mt-8 mb-4' />
        <div className='text-gray-800 text-lg font-semibold'>{name}</div>
        <div className='text-gray-500'>{title}</div>
      </div>
    </ContentPanel>
  );
};

export default TestimonialSection;
